<frontend-header><frontend-header-back-btn></frontend-header-back-btn></frontend-header>

<frontend-check-out [state]="state$ | async" (save)="onSave($event)"></frontend-check-out>
